import { FC, ReactElement } from "react";

interface IProps {
  children?: ReactElement;
  lines?: number;
}

const SkeletonLoading: FC<IProps> = ({ children, lines = 3 }) => {
  return (
    <>
      {!!children?.toString().length ? (
        children
      ) : (
        <div className="skeleton-container">
          {Array.from(Array(lines).keys()).map((element) => (
            <div className="skeleton-element" key={`skeletal-element-${element}`} />
          ))}
        </div>
      )}
    </>
  );
};

export default SkeletonLoading;
